
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/blog-author/[author]",
      function () {
        return require("private-next-pages/blog/blog-author/[author].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/blog-author/[author]"])
      });
    }
  